module.exports = __webpack_public_path__ + "img/Super200.063ec7ad.png";